const Link = (props: { url: string; children: React.ReactNode }) => (
  <a href={props.url} target='_black' className='underline'>
    {props.children}
  </a>
)

export default Link
